import { Environment, AppID } from '@playq/octopus-common';
import { VaultId } from '@playq/services-vault';
import { ServicesCompanyID } from '@playq/services-shared';
import { AliasId, AliasData, IdentityId } from '@playq/services-fingerprint';

export const playerLookupKeys = {
  all: () => ['player', 'service', 'support'],
  allVaults: () => [...playerLookupKeys.all(), 'vault'] as const,
  currentVault: (id: VaultId, env: Environment) => [...playerLookupKeys.allVaults(), id, env] as const,
  loginByAlias: (alias: AliasId, env: Environment, companyID?: ServicesCompanyID) =>
    [...playerLookupKeys.all(), 'login', alias, env, companyID] as const,
  loginByAliasAsUser: (alias: AliasId, env: Environment, update?: AliasData, appID?: AppID) =>
    [...playerLookupKeys.all(), 'login', alias, env, update, appID] as const,
  loginWithPrimaryId: (identityId: IdentityId, env: Environment, appID?: AppID) =>
    [...playerLookupKeys.all(), identityId, env, appID] as const,
  identityProfile: (identityId: IdentityId, env: Environment, companyID?: ServicesCompanyID) =>
    [...playerLookupKeys.all(), identityId, env, companyID] as const,
};
